import React, { useEffect, useState } from "react";
import HolidayPopUp from "./holiday_popup.js";
import BlockHolidayPopUp from "./block_holiday_popup.js";
import "../styles/Holiday.css";
import AddHolidayPopUp from "./add_holiday_popup.js";
import AddDeskReservation from "./addDeskReservation.js";
import HolidayInfo from "./holiday_info.js";
import HolidayAccept from "./holiday_accept.js";
import Loading from "../helpers/loading_component.js";
import { secretKey, monthData } from "../.././data";

const Holiday = (props) => {
  const [monthName, setMonthName] = useState("");
  const [weekName, setWeekName] = useState("");
  const [dateC, setDateC] = useState(
    new Date(props.date).getFullYear() +
      "-" +
      (new Date(props.date).getMonth() < 9
        ? "0" + (new Date(props.date).getMonth() + 1)
        : new Date(props.date).getMonth() + 1) +
      "-" +
      (new Date(props.date).getDate() < 10
        ? "0" + new Date(props.date).getDate()
        : new Date(props.date).getDate())
  );
  const [showHolidayPopUp, setShowHolidayPopUp] = useState(false);
  const [holiday, setHoliday] = useState(null);
  const [block, setBlock] = useState(null);
  const [type, setType] = useState("");
  const [showBlockPopUp, setShowBlockPopUp] = useState(false);
  const [showAddDeskReservation, setShowAddDeskReservation] = useState("");
  const [showBlockEditPopUp, setShowBlockEditPopUp] = useState(false);
  const [showAddHolidayPopUp, setShowAddHolidayPopUp] = useState("");
  const [showHolidayInfo, setShowHolidayInfo] = useState("");
  const [showAcceptPopUp, setShowAcceptPopUp] = useState("");
  const [expandFilters, setExpandFilters] = useState(false);
  const [calMode, setCalMode] = useState(props.holidayView);
  const [loading, setLoading] = useState(true);
  const [holidaysData, setHolidaysData] = useState([]);
  const [yearHolidaysData, setYearHolidaysData] = useState([]);
  const [freeDaysData, setFreeDaysData] = useState([]);
  const [holidaysBlockData, setHolidaysBlockData] = useState([]);

  const openAddDeskReservation = (e) => {
    setShowAddDeskReservation(true);
    setShowAcceptPopUp(false);
    setShowHolidayPopUp(false);
    setShowBlockPopUp(false);
    setShowHolidayInfo(false);
    setShowAddHolidayPopUp(false);
  };

  const closeAddDeskReservation = (e) => {
    setType("");
    setShowAddDeskReservation(false);
    getData();
  };

  const openAddHolidayPopUp = (e) => {
    setType(e.target.value);
    setShowAddHolidayPopUp(true);
  };

  const closeAddHolidayPopUp = (e) => {
    setType("");
    setShowAddHolidayPopUp(false);
    getData();
  };

  const openHolidayPopUp = (e) => {
    setShowHolidayPopUp(true);
    setShowBlockPopUp(false);

    setHoliday(
      holidaysData.filter((el) => +el.id === +e.currentTarget.value)[0]
    );
  };

  const showCalendar = (e) => {
    setShowHolidayPopUp(false);
    setShowBlockPopUp(false);
    setShowHolidayInfo(false);
    setShowAddHolidayPopUp(false);
    setShowAcceptPopUp(false);
    setShowAddDeskReservation(false);
  };

  const openHolidayInfo = (e) => {
    setShowHolidayPopUp(false);
    setShowBlockPopUp(false);
    setShowHolidayInfo(true);
    setShowAddHolidayPopUp(false);
    setShowAcceptPopUp(false);
  };

  const closeHolidayInfo = (e) => {
    setShowHolidayInfo(false);
    getData();
  };

  const openBlockEditPopUp = (e) => {
    setShowBlockEditPopUp(true);
    setShowHolidayPopUp(false);
    setShowBlockPopUp(false);
    setShowAddHolidayPopUp(false);
    setShowAcceptPopUp(false);
    setBlock(
      holidaysBlockData.filter((el) => el.id === e.currentTarget.value)[0]
    );
  };

  const closeBlockEditPopUp = (e) => {
    setShowBlockEditPopUp(false);
    setBlock(null);
    getData();
  };

  const closeHolidayPopUp = (e) => {
    setShowHolidayPopUp(false);
    setHoliday(null);
    getData();
  };

  const openBlockPopUp = (e) => {
    setShowBlockPopUp(true);
    setShowBlockEditPopUp(false);
    setShowHolidayPopUp(false);
    setShowAddHolidayPopUp(false);
    setShowAcceptPopUp(false);
  };

  const closeBlockPopUp = (e) => {
    setShowBlockPopUp(false);
    getData();
  };

  const openAcceptPopUp = (e) => {
    setShowAcceptPopUp(true);
    setShowHolidayPopUp(false);
    setShowBlockPopUp(false);
    setShowHolidayInfo(false);
    setShowAddHolidayPopUp(false);
  };

  const closeAcceptPopUp = (e) => {
    setShowAcceptPopUp(false);
    getData();
  };

  const addDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() + days);
    return dateN;
  };

  const getMonthData = (monthNum) => {
    var data = props.monthData.filter((el) => +el.id === monthNum);
    return data.length > 0 ? data[0].name : "";
  };

  const subDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() - days);
    return dateN;
  };

  const createMonthSet = () => {
    var date = dateC;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var daysArray = [];
    var beginCounter = startMonthDate;
    while (beginCounter >= startMonthDate && beginCounter <= endMonthDate) {
      daysArray.push(
        `${beginCounter.getFullYear()}-${
          beginCounter.getMonth() + 1 < 10
            ? "0" + (beginCounter.getMonth() + 1)
            : beginCounter.getMonth() + 1
        }-${
          beginCounter.getDate() < 10
            ? "0" + beginCounter.getDate()
            : beginCounter.getDate()
        }`
      );
      beginCounter.setDate(beginCounter.getDate() + 1);
    }

    return daysArray;
  };

  const createWeekSet = () => {
    var date = new Date(dateC);

    var dayStart = new Date(date).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;
    var startWeekDate = subDays(date, daysToSubStart);

    var weekArray = [];

    for (var i = 0; i <= 6; ++i) {
      var actualDate = addDays(startWeekDate, i);

      weekArray.push(
        `${actualDate.getFullYear()}-${
          actualDate.getMonth() + 1 < 10
            ? "0" + (actualDate.getMonth() + 1)
            : actualDate.getMonth() + 1
        }-${
          actualDate.getDate() < 10
            ? "0" + actualDate.getDate()
            : actualDate.getDate()
        }`
      );
    }

    return weekArray;
  };

  const fetchHolidays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidaysData(data);
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDaysData(data);
      })
      .catch((error) => {});
  };

  const fetchHolidaysBlocks = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHolidaysBlocks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidaysBlockData(data);
        fetchYearHolidays();
      })
      .catch((error) => {});
  };

  const fetchYearHolidays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getYearsHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setYearHolidaysData(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchHolidays();
    fetchFreeDays();
    fetchHolidaysBlocks();

    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    setMonthName(getMonthData(month) + " " + year);
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date(date).getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + weekNumber);
  };

  useEffect(() => {
    getData();
  }, []);

  const getInitials = (user) => {
    var newData = props.users.filter((el) => el.name === user);
    if (newData.length > 0) {
      return newData[0].initials;
    } else {
      return "";
    }
  };

  const handleExpandFiltersClick = (e) => {
    setExpandFilters(!expandFilters);
  };

  const getHoliday = (date) => {
    if (
      new Date(date).getDay() === 6 ||
      new Date(date).getDay() === 0 ||
      checkFreeDay(date)
    ) {
      return [];
    }

    var holidays = holidaysData.filter(
      (el) =>
        date >= new Date(el.date_from).setHours(0) &&
        date <= new Date(el.date_to) &&
        el.type === "holiday"
    );
    return holidays;
  };

  const getSick = (date) => {
    if (
      new Date(date).getDay() === 6 ||
      new Date(date).getDay() === 0 ||
      checkFreeDay(date)
    ) {
      return [];
    }
    var holidays = holidaysData.filter(
      (el) =>
        date >= new Date(el.date_from).setHours(0) &&
        date <= new Date(el.date_to) &&
        el.type === "sick"
    );
    return holidays;
  };

  const getRemote = (date) => {
    if (
      new Date(date).getDay() === 6 ||
      new Date(date).getDay() === 0 ||
      checkFreeDay(date)
    ) {
      return [];
    }
    var holidays = holidaysData.filter(
      (el) =>
        date >= new Date(el.date_from).setHours(0) &&
        date <= new Date(el.date_to) &&
        el.type === "remote"
    );
    return holidays;
  };

  const getEkwiwalent = (date) => {
    if (
      new Date(date).getDay() === 6 ||
      new Date(date).getDay() === 0 ||
      checkFreeDay(date)
    ) {
      return [];
    }
    var holidays = holidaysData.filter(
      (el) =>
        date >= new Date(el.date_from).setHours(0) &&
        date <= new Date(el.date_to) &&
        el.type === "ekwiwalent"
    );
    return holidays;
  };

  const checkFreeDay = (date) => {
    var free = freeDaysData.filter((el) => new Date(date) === new Date(el));
    if (free.length > 0) {
      return true;
    }
    return false;
  };

  const getBlock = (date) => {
    if (
      new Date(date).getDay() === 6 ||
      new Date(date).getDay() === 0 ||
      checkFreeDay(date)
    ) {
      return [];
    }
    var holidays = holidaysBlockData.filter(
      (el) => date >= new Date(el.date_from) && date <= new Date(el.date_to)
    );
    return holidays;
  };

  const calendarWeekNew = (
    <>
      {showAddDeskReservation ? (
        <AddDeskReservation
          close={closeAddDeskReservation}
          users={props.users}
          mode={"add"}
          holiday={props.holiday}
          user={props.user}
          holidaysData={holidaysData}
          holidaysBlockData={holidaysBlockData}
          holidaysSheetData={props.holidaysSheetData}
          refreshData={props.refreshData}
          team={props.team}
          type={type}
          date={props.date}
          freeDaysData={freeDaysData}
          deskResData={props.deskResData}
          desksData={props.desksData}
          deskResSheetData={props.deskResSheetData}
        />
      ) : (
        ""
      )}
      {showAddHolidayPopUp ? (
        <AddHolidayPopUp
          close={closeAddHolidayPopUp}
          users={props.users}
          mode={"add"}
          holiday={props.holiday}
          user={props.user}
          holidaysData={holidaysData}
          holidaysBlockData={holidaysBlockData}
          holidaysSheetData={props.holidaysSheetData}
          refreshData={props.refreshData}
          team={props.team}
          type={type}
        />
      ) : (
        ""
      )}
      {showBlockPopUp ? (
        <BlockHolidayPopUp
          close={closeBlockPopUp}
          holiday={holiday}
          holidaysSheetData={props.holidaysSheetData}
          holidaysBlockSheetData={props.holidaysBlockSheetData}
          holidaysBlockData={holidaysBlockData}
          holidaysData={holidaysData}
          refreshData={props.refreshData}
          mode={"add"}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showBlockEditPopUp ? (
        <BlockHolidayPopUp
          close={closeBlockEditPopUp}
          block={block}
          holidaysSheetData={props.holidaysSheetData}
          holidaysBlockSheetData={props.holidaysBlockSheetData}
          holidaysBlockData={holidaysBlockData}
          holidaysData={holidaysData}
          refreshData={props.refreshData}
          mode="edit"
          team={props.team}
        />
      ) : (
        ""
      )}
      {showHolidayPopUp ? (
        <HolidayPopUp
          close={closeHolidayPopUp}
          holiday={holiday}
          holidaysSheetData={props.holidaysSheetData}
          holidaysBlockData={holidaysBlockData}
          holidaysData={holidaysData}
          refreshData={props.refreshData}
          users={props.users}
          user={props.user}
          team={props.team}
        />
      ) : showHolidayInfo ? (
        <HolidayInfo
          close={closeHolidayInfo}
          holiday={holiday}
          holidaysSheetData={props.holidaysSheetData}
          holidaysBlockData={holidaysBlockData}
          holidaysData={holidaysData}
          refreshData={props.refreshData}
          users={props.users}
          user={props.user}
          team={props.team}
          freeDaysData={freeDaysData}
          freeDaysSheetData={props.freeDaysSheetData}
          yearHolidaysData={yearHolidaysData}
        />
      ) : showAddDeskReservation ? (
        ""
      ) : (
        <>
          <div className="navigationCalendar">
            <>
              <div className="sectionTitleCalendar">{weekName}</div>
              <button
                className="navigationArrow"
                value="previous"
                onClick={props.setDateWeek}
              >
                &#8592;
              </button>
              <button
                className="navigationArrow"
                value="next"
                onClick={props.setDateWeek}
              >
                &#8594;
              </button>
            </>
          </div>
          <div className="rowCalendar">
            {createWeekSet().map((el) => (
              <>
                <div key={el} className="cellCalendarWeek">
                  <div
                    id={"cb" + new Date(el).getDate()}
                    className="cellBoxWeek"
                    style={{ maxHeight: "53vh" }}
                  >
                    {getHoliday(new Date(el)).map((el2) => (
                      <>
                        <>
                          <button
                            key={el2.id}
                            style={
                              el2.status === "REPORTED"
                                ? { backgroundColor: "red" }
                                : { backgroundColor: "green" }
                            }
                            id="monthLink"
                            className="caseLink"
                            value={el2.id}
                            onClick={openHolidayPopUp}
                          >
                            <div className="titleBox">
                              <div id="titleHoliday" className="titleBox_col1">
                                Urlop {getInitials(el2.user)}
                              </div>
                            </div>
                          </button>{" "}
                        </>
                      </>
                    ))}
                    {getBlock(new Date(el)).map((el3) => (
                      <>
                        <>
                          <button
                            key={el3.id}
                            style={{ backgroundColor: "black" }}
                            id="monthLink"
                            className="caseLink"
                            value={el3.id}
                            onClick={openBlockEditPopUp}
                          >
                            <div className="titleBox">
                              <div id="titleHoliday" className="titleBox_col1">
                                Blokada
                              </div>
                            </div>
                          </button>{" "}
                        </>
                      </>
                    ))}
                    {getSick(new Date(el)).map((el4) => (
                      <>
                        <>
                          <button
                            key={el4.id}
                            style={{ backgroundColor: "blue" }}
                            id="monthLink"
                            className="caseLink"
                            value={el4.id}
                            onClick={openHolidayPopUp}
                          >
                            <div className="titleBox">
                              <div id="titleHoliday" className="titleBox_col1">
                                Chorobowe {getInitials(el4.user)}
                              </div>
                            </div>
                          </button>{" "}
                        </>
                      </>
                    ))}
                    {getRemote(new Date(el)).map((el5) => (
                      <>
                        <>
                          <button
                            key={el5.id}
                            style={{
                              backgroundColor: "yellow",
                              color: "black",
                            }}
                            id="monthLink"
                            className="caseLink"
                            value={el5.id}
                            onClick={openHolidayPopUp}
                          >
                            <div className="titleBox">
                              <div id="titleHoliday" className="titleBox_col1">
                                Praca zdalna {getInitials(el5.user)}
                              </div>
                            </div>
                          </button>{" "}
                        </>
                      </>
                    ))}
                    {props.user.urlopyAdmin === "1"
                      ? getEkwiwalent(new Date(el)).map((el5) => (
                          <>
                            <>
                              <button
                                key={el5.id}
                                style={{
                                  backgroundColor: "lightgray",
                                  color: "white",
                                }}
                                id="monthLink"
                                className="caseLink"
                                value={el5.id}
                                onClick={openHolidayPopUp}
                              >
                                <div className="titleBox">
                                  <div
                                    id="titleHoliday"
                                    className="titleBox_col1"
                                  >
                                    Ekwiwalent {getInitials(el5.user)}
                                  </div>
                                </div>
                              </button>{" "}
                            </>
                          </>
                        ))
                      : ""}
                  </div>
                  <span className="cellDayNumber">{el}</span>
                </div>
              </>
            ))}
          </div>
        </>
      )}
    </>
  );

  const scrollBox = (e) => {
    const divToScrollTo = document.getElementById("cb" + e.target.value);
    divToScrollTo.scrollTo({
      top: divToScrollTo.scrollTop + 100,
      behavior: "smooth",
    });
  };

  const calendarMonthNew = (
    <>
      {showAddDeskReservation ? (
        <AddDeskReservation
          close={closeAddDeskReservation}
          users={props.users}
          mode={"add"}
          holiday={props.holiday}
          user={props.user}
          holidaysData={holidaysData}
          holidaysBlockData={holidaysBlockData}
          holidaysSheetData={props.holidaysSheetData}
          refreshData={props.refreshData}
          team={props.team}
          type={type}
          date={props.date}
          freeDaysData={freeDaysData}
          deskResData={props.deskResData}
          desksData={props.desksData}
          deskResSheetData={props.deskResSheetData}
        />
      ) : (
        ""
      )}
      {showAddHolidayPopUp ? (
        <AddHolidayPopUp
          close={closeAddHolidayPopUp}
          users={props.users}
          mode={"add"}
          holiday={props.holiday}
          user={props.user}
          holidaysData={holidaysData}
          holidaysBlockData={holidaysBlockData}
          holidaysSheetData={props.holidaysSheetData}
          refreshData={props.refreshData}
          team={props.team}
          type={type}
        />
      ) : (
        ""
      )}
      {showBlockPopUp ? (
        <BlockHolidayPopUp
          close={closeBlockPopUp}
          holiday={holiday}
          holidaysSheetData={props.holidaysSheetData}
          holidaysBlockSheetData={props.holidaysBlockSheetData}
          holidaysBlockData={holidaysBlockData}
          holidaysData={holidaysData}
          refreshData={props.refreshData}
          mode={"add"}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showBlockEditPopUp ? (
        <BlockHolidayPopUp
          close={closeBlockEditPopUp}
          block={block}
          holidaysSheetData={props.holidaysSheetData}
          holidaysBlockSheetData={props.holidaysBlockSheetData}
          holidaysBlockData={holidaysBlockData}
          holidaysData={holidaysData}
          refreshData={props.refreshData}
          mode="edit"
          team={props.team}
        />
      ) : (
        ""
      )}
      {showHolidayPopUp ? (
        <HolidayPopUp
          close={closeHolidayPopUp}
          holiday={holiday}
          holidaysSheetData={props.holidaysSheetData}
          holidaysBlockData={holidaysBlockData}
          holidaysData={holidaysData}
          refreshData={props.refreshData}
          users={props.users}
          user={props.user}
          team={props.team}
        />
      ) : showHolidayInfo ? (
        <HolidayInfo
          close={closeHolidayInfo}
          holiday={holiday}
          holidaysSheetData={props.holidaysSheetData}
          holidaysBlockData={holidaysBlockData}
          holidaysData={holidaysData}
          refreshData={props.refreshData}
          users={props.users}
          user={props.user}
          team={props.team}
          freeDaysData={freeDaysData}
          freeDaysSheetData={props.freeDaysSheetData}
          yearHolidaysData={props.yearHolidaysData}
        />
      ) : showAcceptPopUp ? (
        <HolidayAccept
          close={closeAcceptPopUp}
          holiday={holiday}
          holidaysSheetData={props.holidaysSheetData}
          holidaysBlockData={holidaysBlockData}
          holidaysData={holidaysData}
          refreshData={props.refreshData}
          users={props.users}
          user={props.user}
          team={props.team}
          freeDaysData={freeDaysData}
          freeDaysSheetData={props.freeDaysSheetData}
        />
      ) : showAddDeskReservation ? (
        ""
      ) : (
        <>
          {loading ? (
            <Loading id="popUpLoading" />
          ) : (
            <>
              <div className="navigationCalendar">
                <>
                  <div
                    className="sectionTitleCalendar"
                    style={{ width: "40vw" }}
                  >
                    {monthName}
                  </div>
                  <button
                    className="navigationArrow"
                    value="previous"
                    onClick={props.setDate}
                  >
                    &#8592;
                  </button>
                  <button
                    className="navigationArrow"
                    value="next"
                    onClick={props.setDate}
                  >
                    &#8594;
                  </button>
                </>
              </div>
              <div className="rowCalendar">
                {createMonthSet().map((el) => (
                  <>
                    <div key={el} className="cellCalendar">
                      <div
                        id={
                          "cb" +
                          new Date(el).getMonth() +
                          new Date(el).getDate()
                        }
                        className="cellBox"
                      >
                        {getHoliday(new Date(el)).map((el2) => (
                          <>
                            <>
                              <button
                                key={el2.id}
                                style={
                                  el2.status === "REPORTED"
                                    ? { backgroundColor: "red" }
                                    : { backgroundColor: "green" }
                                }
                                id="monthLink"
                                className="caseLink"
                                value={el2.id}
                                onClick={openHolidayPopUp}
                              >
                                <div className="titleBox">
                                  <div
                                    id="titleHoliday"
                                    className="titleBox_col1"
                                  >
                                    Urlop {getInitials(el2.user)}
                                  </div>
                                </div>
                              </button>{" "}
                            </>
                          </>
                        ))}
                        {getBlock(new Date(el)).map((el3) => (
                          <>
                            <>
                              <button
                                key={el3.id}
                                style={{ backgroundColor: "black" }}
                                id="monthLink"
                                className="caseLink"
                                value={el3.id}
                                onClick={openBlockEditPopUp}
                              >
                                <div className="titleBox">
                                  <div
                                    id="titleHoliday"
                                    className="titleBox_col1"
                                  >
                                    Blokada
                                  </div>
                                </div>
                              </button>{" "}
                            </>
                          </>
                        ))}
                        {getSick(new Date(el)).map((el4) => (
                          <>
                            <>
                              <button
                                key={el4.id}
                                style={{ backgroundColor: "blue" }}
                                id="monthLink"
                                className="caseLink"
                                value={el4.id}
                                onClick={openHolidayPopUp}
                              >
                                <div className="titleBox">
                                  <div
                                    id="titleHoliday"
                                    className="titleBox_col1"
                                  >
                                    Chorobowe {getInitials(el4.user)}
                                  </div>
                                </div>
                              </button>{" "}
                            </>
                          </>
                        ))}
                        {getRemote(new Date(el)).map((el5) => (
                          <>
                            <>
                              <button
                                key={el5.id}
                                style={{
                                  backgroundColor: "yellow",
                                  color: "black",
                                }}
                                id="monthLink"
                                className="caseLink"
                                value={el5.id}
                                onClick={openHolidayPopUp}
                              >
                                <div className="titleBox">
                                  <div
                                    id="titleHoliday"
                                    className="titleBox_col1"
                                  >
                                    Praca zdalna {getInitials(el5.user)}
                                  </div>
                                </div>
                              </button>{" "}
                            </>
                          </>
                        ))}
                        {props.user.urlopyAdmin === "1"
                          ? getEkwiwalent(new Date(el)).map((el5) => (
                              <>
                                <>
                                  <button
                                    key={el5.id}
                                    style={{
                                      backgroundColor: "lightgray",
                                      color: "white",
                                    }}
                                    id="monthLink"
                                    className="caseLink"
                                    value={el5.id}
                                    onClick={openHolidayPopUp}
                                  >
                                    <div className="titleBox">
                                      <div
                                        id="titleHoliday"
                                        className="titleBox_col1"
                                      >
                                        Ekwiwalent {getInitials(el5.user)}
                                      </div>
                                    </div>
                                  </button>{" "}
                                </>
                              </>
                            ))
                          : ""}
                      </div>
                      <div className="weekSpecialBoxB">
                        {getRemote(new Date(el)).length +
                          getSick(new Date(el)).length +
                          getBlock(new Date(el)).length +
                          getHoliday(new Date(el)).length +
                          getEkwiwalent(new Date(el)).length >
                        4 ? (
                          <button
                            value={
                              new Date(el).getMonth().toString() +
                              new Date(el).getDate().toString()
                            }
                            onClick={scrollBox}
                            className="moreButtonCalendar"
                          >
                            ▼
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                      <span className="cellDayNumber">{el}</span>
                    </div>
                  </>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </>
  );

  const total_days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24)) + 1;
    return TotalDays;
  };

  const getReportedDays = (name) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name && el.status === "REPORTED" && el.type === "holiday"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + total_days(new Date(el.date_to), new Date(el.date_from));
    });
    return days;
  };

  const getAcceptedDays = (name) => {
    var holidays = holidaysData.filter(
      (el) =>
        el.user === name && el.status === "ACCEPTED" && el.type === "holiday"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + total_days(new Date(el.date_to), new Date(el.date_from));
    });
    return days;
  };

  const setViewWeek = (e) => {
    props.setViewWeek();
  };

  const setViewMonth = (e) => {
    props.setViewMonth();
  };

  return (
    <>
      <div id="holidayCalendar" className="mainContainerCalendar">
        <div style={{ width: "100%" }} className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="holidayMenuContainer">
          <button className="paymentMenuButton" onClick={showCalendar}>
            Kalendarz urlopowy
          </button>
          {calMode === "week" ? (
            <button
              className="paymentMenuButton"
              value="remote"
              onClick={setViewMonth}
            >
              Pokaż widok miesięczny
            </button>
          ) : (
            ""
          )}
          {calMode === "month" ? (
            <button
              className="paymentMenuButton"
              value="remote"
              onClick={setViewWeek}
            >
              Pokaż widok tygodniowy
            </button>
          ) : (
            ""
          )}
          <button className="paymentMenuButton" onClick={openHolidayInfo}>
            Informacja o urlopach
          </button>
          <button className="paymentMenuButton" onClick={openBlockPopUp}>
            Dodaj blokadę
          </button>
          <button
            className="paymentMenuButton"
            value="holiday"
            onClick={openAddHolidayPopUp}
          >
            Dodaj urlop
          </button>
          <button
            className="paymentMenuButton"
            value="sick"
            onClick={openAddHolidayPopUp}
          >
            Dodaj zwolnienie chorobowe
          </button>
          <button
            className="paymentMenuButton"
            value="remote"
            onClick={openAddHolidayPopUp}
          >
            Dodaj pracę zdalną
          </button>
          <button
            className="paymentMenuButton"
            value="remote"
            onClick={openAddDeskReservation}
          >
            Rezerwacja biurka / Praca zdalna
          </button>
          <button
            className="paymentMenuButton"
            value="ekwiwalent"
            onClick={openAddHolidayPopUp}
          >
            Dodaj ekwiwalent
          </button>
          <button
            className="paymentMenuButton"
            value="remote"
            onClick={openAcceptPopUp}
          >
            Wnioski urlopowe do akceptacji
          </button>
        </div>
        {loading ? (
          <Loading />
        ) : calMode === "month" ? (
          calendarMonthNew
        ) : (
          calendarWeekNew
        )}
      </div>
    </>
  );
};

export default Holiday;
